function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.32 3a2.5 2.5 0 00-2.5 2.5v7h2v-7a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v13a.5.5 0 01-.5.5h-2.5a1 1 0 00-1 1v1.92l-3.375-2.7v2.56l3.75 3A1 1 0 0024.82 24v-3h1.5a2.5 2.5 0 002.5-2.5v-13a2.5 2.5 0 00-2.5-2.5h-17z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.32 14a2.5 2.5 0 00-2.5 2.5v6a2.5 2.5 0 002.5 2.5h1.5v3a1 1 0 001.664.747L12.7 25h2.62a2.5 2.5 0 002.5-2.5v-6a2.5 2.5 0 00-2.5-2.5h-10zm-.5 2.5a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-3a1 1 0 00-.665.253l-2.835 2.52V24a1 1 0 00-1-1h-2.5a.5.5 0 01-.5-.5v-6z",
  fill: "currentColor"
})));